//Import required libraries
import React, { useState } from 'react';

const TextInput = props => {

    let { name, label, disabled, userInput, setUserInput } = props

    const handleChange = event => {
        setUserInput({
            ...userInput,
            [name]: event.target.value,
        })
    }

    return (
        <div>
        <input type="text"
                value={userInput[name]}
                disabled={disabled}
                onChange={handleChange}
        />
        </div>
    );
}

export default TextInput


